// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_ml-0";
export var buttonContainer = "_ml-3";
export var cancelButton = "_ml-4";
export var headerSection = "_ml-6";
export var headerTitle = "_ml-9";
export var messageSideLeft = "_ml-1";
export var messageSideRight = "_ml-2";
export var orderNumberContainer = "_ml-7";
export var orderNumberLabel = "_ml-8";
export var submitButton = "_ml-5";